export const swedishCountryCodeString = '(\\+|00)46';
export const swedishCountryCode = new RegExp(`^${swedishCountryCodeString}`);
